import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=57311b31&scoped=true"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"
import style0 from "./ServiceCenter.vue?vue&type=style&index=0&id=57311b31&prod&lang=scss&scoped=true"
import style1 from "./ServiceCenter.vue?vue&type=style&index=1&id=57311b31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57311b31",
  null
  
)

export default component.exports